import { render, staticRenderFns } from "./JudgeSettings.vue?vue&type=template&id=4412635c&scoped=true"
import script from "./JudgeSettings.vue?vue&type=script&lang=js"
export * from "./JudgeSettings.vue?vue&type=script&lang=js"
import style0 from "./JudgeSettings.vue?vue&type=style&index=0&id=4412635c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412635c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4412635c')) {
      api.createRecord('4412635c', component.options)
    } else {
      api.reload('4412635c', component.options)
    }
    module.hot.accept("./JudgeSettings.vue?vue&type=template&id=4412635c&scoped=true", function () {
      api.rerender('4412635c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/JudgeSettings.vue"
export default component.exports